/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Inventory {
    import fld = ConvertToWIPBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ConvertToWIPBOMEditor extends _Ext.BOMGridEditor<ConvertToWIPBOMRow> { 
        protected getDialogType() { return ConvertToWIPBOMDialog; }
        protected getLocalTextPrefix() { return ConvertToWIPBOMRow.localTextPrefix; } 
        public pendingChanges: Q.Dictionary<any> = {};
         
        public Pieces: number;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

        } 
        // #region Column Add -Remove
        protected getColumns() {


            var columns = super.getColumns();
            var pieces = this.Pieces;
            let piecesColumn = Q.first(columns, x => x.field == fld.Pieces);

            piecesColumn.format = ctx => {
                if (pieces>1)
                    return ColumnFormatter.integerInputFormatter(ctx, this);
                else
                    return ColumnFormatter.integerReadOnlyFormatter(ctx,this);
            }
            let weightColumn = Q.first(columns, x => x.field == fld.Weight);

            weightColumn.format = ctx => {
                if (pieces > 1)
                    return ColumnFormatter.WeightFormatter(ctx, this);
                else
                    return ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
            }
            Q.first(columns, x => x.field == fld.BomRate).format = ctx =>ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
            return columns;
        }

        //Row Edit Event handler
        public inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.BomRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }

            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.BomRate && value > 0) {
                if (item.CalcOnId == 3) {
                    item.BomAmount = value * item.Pieces;
                } else if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.BomAmount = value * item.Weight;
                }
                item[field] = value;
            }



            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialMasterSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var purchasedetails = [];
                        var ratelistId = this.RateListId;
                        //alert(selectedItems2.length);
                        selectedItems2.forEach(function (value) {
                            var prdid = value.ProductId;
                            var atbid = value.AttributeId;
                            var atbDetails = value;

                            var atbCode = atbDetails.Attribute;
                            var ItmTpy = atbDetails.ItemType;
                            var ItmTpyId = atbDetails.ItemTypeId;
                            var TypeID = atbDetails.CategoryId;
                            var SubTypeID = atbDetails.SubCategoryId;
                            var SubType = atbDetails.SubCategoryCode;
                            var Karat = atbDetails.KaratCode;
                            var KaratId = atbDetails.KaratId;
                            var StoneColorID = atbDetails.StoneColorId;
                            var MetalColorId = atbDetails.MetalColorId;
                            var CalcOn = value.CalcOnId;

                            var ShapeID = atbDetails.ShapeId;
                            var Quality = atbDetails.QualityCode;
                            var QualityId = atbDetails.QualityId;
                            var Purity = value.Purity;
                            var Pieces = 0;
                            var Weight = 0.01;
                            var Rate = 0;
                            var Amount = 0;

                            if (SubTypeID == 301 || SubTypeID == 302 || SubTypeID == 303 || SubTypeID == 304) {
                                var MetalRate = GetItemRateHelper.GetGetMetalRate(SubTypeID);
                                Rate = MetalRate;
                                Amount = Rate * Weight * Purity;

                            }
                            else {
                                var ItemRate = GetItemRateHelper.GetPurchaseRate(atbid, ratelistId);
                                Rate = ItemRate;
                                Pieces = 1;
                                if (CalcOn == 3) {
                                    Amount = Rate * Pieces
                                }
                                else {
                                    Amount = Rate * Weight;
                                }
                            }


                            var purchaseBom: ConvertToWIPBOMRow = {
                                BOMProductId: prdid,

                                ProductCode: value.ProductCode,
                                BOMAttributeId: value.AttributeId,
                                Attribute: atbCode,
                                ItemType: ItmTpy,
                                ItemTypeId: ItmTpyId,


                                StoneColorId: StoneColorID,
                                MetalColorId: MetalColorId,
                                KaratId: KaratId,

                                BomRate: Rate,
                                Pieces: Pieces,
                                Weight: Weight,
                                CalcOn: value.CalcOnId,
                                ShapeId: ShapeID,
                                QualityId: QualityId,

                                Purity: Purity,
                                BomAmount: Amount
                            };
                            purchasedetails.push(purchaseBom);

                        });


                        for (let purchaseDetail of purchasedetails) {
                            purchaseDetail[this.getIdProperty()] = "`" + this.nextId++;
                            //alert('ID ' + purchaseDetail.PrdBomId);
                            var x = purchaseDetail;
                            this.view.addItem(purchaseDetail);

                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }

        public getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        } 
    }
}